  <div class="modal-body">
    <span class="close-icon" (click)="closeDialog()">x</span>
    <ng-template dialogHost></ng-template>
  </div>